<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>To Ennis,<br/>before she goes off and leaves her old dad</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?646c4226